"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowPromoEffectConverter.
 *
 * @author VSm
 */


var WindowPromoEffectSiteConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowPromoEffectSiteConverter, _DataObjectConverter_);

  function WindowPromoEffectSiteConverter() {
    _classCallCheck(this, WindowPromoEffectSiteConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowPromoEffectSiteConverter).apply(this, arguments));
  }

  return WindowPromoEffectSiteConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowPromoEffectSiteConverter = WindowPromoEffectSiteConverter;